import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Box,
  TextField,
  InputAdornment,
  InputLabel,
  Typography,
} from "@mui/material";
import { ReactComponent as SearchIcon } from "../../assests/icons/search_icon.svg";
import { ReactComponent as SearchBigImage } from "../../assests/icons/search_bigimg.svg";
import { SearchButton } from "./AddConnections.styles";
import SearchList from "../../components/Connections/SearchList";
import { ConnectionsToken, ErrorToken, homeToken, laptopMQL } from "../../utils/constant";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

const searchTextfiled = {
  width: "583px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    border: "1px solid #D9D9D9 !important",
    borderRadius: "4px",
    boxShadow: "5px 5px 5px 5px rgba(0, 0, 0, 0.07) !important",
  },
  ".MuiInputBase-input": { color: '#64666A' },
  [laptopMQL]:{
    ".MuiInputBase-input": {
      padding:"1rem 1.4rem 1rem 0.5rem"
    },
    ".search-ico":{
      height:"2.2rem",
      
    }
  },
  "@media only screen and (min-width: 650px) and (max-width: 830px)":{
    width: "590px",
    padding:"0"
  },
  "@media only screen and (max-width: 649px)":{
    width: "35.6rem"
  }
};

const AddConnections = () => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [finalSearchText, setFinalSeachText] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const [searchFieldError, setSearchFieldError] = useState(false);
  const theme = useTheme();

  const searchFieldChangeHandler = (e) => {
    setSearchText(e.target.value);
    setSearchFieldError(false);
  };
  const searchConnections = () => {
    if (searchText.trim() && searchText.trim().length >= 3) {
      setFinalSeachText(searchText.trim());
      let data = {
        search: searchText.trim(),
      };
      setSearchParams(data);
    } else {
      setSearchFieldError(true);
    }
  };

  return (
    <>
      {searchParams.size > 0 ? (
        <SearchList
          searchText={finalSearchText || searchParams.get("search")}
        />
      ) : (
        <Box
          component={"div"}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "70vh",
          }}
        >
          <Box component={"div"}>
            <Box>
              <Box component={"div"} sx={{ display: "flex", gap: "2.4rem",
                "@media only screen and (max-width: 830px)":{
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "0.5rem",
                      marginBottom:"1rem"
              }
               }}>
                <Box component={"div"}>
                  <InputLabel
                    htmlFor="input-with-icon-adornment"
                    sx={{
                      color: "#64666A",
                      fontSize: "2.2rem",
                      fontWeight: "500",
                      textAlign: theme.direction === "rtl" ? "right" : "left",
                      [laptopMQL]:{
                        fontSize: "1.8rem",
                      }
                    }}
                  >
                    {t(ConnectionsToken.SearchDirectory)}
                  </InputLabel>
                  <TextField
                    autoFocus={true}
                    sx={searchTextfiled}
                    placeholder={t(homeToken.Search)}
                    value={searchText}
                    onChange={searchFieldChangeHandler}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon className="search-ico" />
                        </InputAdornment>
                      ),
                    }}
                    onKeyDown={e=> e.key  === 'Enter' && searchConnections()}
                  />
                   <Typography
                sx={{
                  color: "#cf2030",
                  textAlign: theme.direction === "rtl" ? "right" : "left",
                  visibility: searchFieldError ? "visible" : "hidden",
                  padding: "1rem 2.5rem 0rem 0.5rem"
                }}
              >
                {t(ErrorToken.SearchLenghtError)}
              </Typography>
                </Box>
                <Box component={"div"}>
                  <InputLabel
                    sx={{ fontSize: "2.3rem",[laptopMQL]:{
                      lineHeight: "normal"
              } }}
                    htmlFor="input-with-icon-adornment"
                  >
                    {" "}
                    &nbsp;
                  </InputLabel>
                  <SearchButton title={t(homeToken.Search)} onClick={searchConnections}>
                    {t(homeToken.Search)}
                  </SearchButton>
                </Box>
              </Box>
            </Box>
            <Box component={"div"} sx={{ mt: 10 }}>
              <SearchBigImage />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default AddConnections;
